import { useEffect, useState } from 'react';

import AddTheme from '../../components/theme/add-theme/add-theme.component';
import Button from '../../components/reusable/button/button.component';
import Spinner from '../../components/reusable/spinner/spinner.component';
// import ThemeImages from '../../components/theme/theme-images/theme-images.component';
import ThemesTable from '../../components/reusable/tables/themes-table/themes-table.component';

import Client from "../../tools/client";

import {
    ConfigurationTitle,
    ContentContainer,
    MainContainer,
    TabContainer,
    TabSelector,
    Title
} from './themes.styles';

const client = new Client();

const ThemesPage = () => {
    const [ loading, setLoading ] = useState(true);
    const [ loadData, setLoadData ] = useState(false);
    const [ themes, setThemes ] = useState([]);
    const [ showUpdate, setShowUpdate ] = useState(false);

    const [ page, setPage ] = useState(0);
    const [ size, setSize ] = useState(10);
    const [ search, setSearch ] = useState('');
    const [ sortKey, setSortKey ] = useState('');
    const [ sortDirection, setSortDirection ] = useState('');

    const [ currentTab, setCurrentTab ] = useState(1);
    const [ tabOneActive, setTabOneActive ] = useState(true);
    const [ tabTwoActive, setTabTwoActive ] = useState(false);
    const [ tabThreeActive, setTabThreeActive ] = useState(false);

    useEffect(() => {
        getConfiguration();
    }, []);

    const getConfiguration = async () => {
        setLoading(true);
        const res = await client.getThemes();
        setThemes(res.rows);
        setLoading(false);
    }

    // TODO: Delete after order item upgrade

    const getOldOrders = async () => {
        const res = await client.getLegacyOrders();

        console.log('GET Old Orders res: ', res);
    }

    const upgradeOrders = async () => {
        const res = await client.upgradeLegacyOrders({ dryRun: false });

        console.log('Upgrade Orders res: ', res);
    }

    const getOldOrderFulfillments = async () => {
        console.log('GET Orders without Fulfillments hit');
        const res = await client.getLegacyOrderFulfillments();

        console.log('GET Old Order Fulfillments res: ', res);
    }

    const upgradeOrderFulfillments = async () => {
        const res = await client.upgradeLegacyOrderFulfillments();

        console.log('Upgrade Order Fulfillments res: ', res);
    }

    const updateCMS = async () => {
        await client.updateCMS();
    }

    const activateTabOne = () => {
        setCurrentTab(1);
        setTabOneActive(true);
        setTabTwoActive(false);
        setTabThreeActive(false);
    }

    const activateTabTwo = () => {
        setCurrentTab(2);
        setTabOneActive(false);
        setTabTwoActive(true);
        setTabThreeActive(false);
    }

    const activateTabThree = () => {
        setCurrentTab(3);
        setTabOneActive(false);
        setTabTwoActive(false);
        setTabThreeActive(true);
    }

    const showCurrentTab = () => {
        if(currentTab === 2) {
            return (
                <AddTheme />
            )
        }

        if(currentTab === 3) {
            return (
                // <ThemeImages />
                <></>
            )
        }

        return (
            <ContentContainer>
                {/* <Select value={size} onChange={(e) => changeSize(e.target.value)} maxWidth={'100px'} marginBottom={'20px'}>
                    <Option key={1} value={10}>10</Option>
                    <Option key={2} value={25}>25</Option>
                    <Option key={3} value={50}>50</Option>
                    <Option key={4} value={100}>100</Option>
                </Select> */}

                <Title>Themes</Title>

                <Button onClick={() => getOldOrders()}>GET Orders</Button>
                <Button onClick={() => upgradeOrders()}>UPGRADE Orders</Button>

                <Button onClick={() => getOldOrderFulfillments()}>GET Order Fulfillments</Button>
                <Button onClick={() => upgradeOrderFulfillments()}>UPGRADE Order Fulfillments</Button>

                <ThemesTable 
                    themes={themes}
                    sortKey={sortKey}
                    setSortKey={setSortKey}
                    sortDirection={sortDirection}
                    setSortDirection={setSortDirection}
                    reloadTable={setLoadData}
                />
                {/* <Pagination
                    count={productsCount}
                    size={size}
                    page={page}
                    changePage={changePage}
                /> */}
            </ContentContainer>
        )
    }

    return (
        <MainContainer>
            <TabContainer>
                <TabSelector active={tabOneActive} onClick={() => activateTabOne()}>Themes</TabSelector>
                <TabSelector active={tabTwoActive} onClick={() => activateTabTwo()}>Add Theme</TabSelector>
                {/* <TabSelector active={tabThreeActive} onClick={() => activateTabThree()}>Theme Images</TabSelector> */}
            </TabContainer>
            <ContentContainer>
                {loading ?
                    <Spinner />
                :
                    showCurrentTab()
                }
            </ContentContainer>
        </MainContainer>
    )
}

export default ThemesPage;